import React, { useEffect, useState } from 'react';
import shuffle from 'lodash.shuffle';
import { useTranslation } from 'react-i18next';
import GuessTheYearQuestion from './mini-games/GuessTheYearQuestion';
import WhichCameFirstQuestion from './mini-games/WhichCameFirstQuestion';
import FillInTheBlankQuestion from './mini-games/FillInTheBlankQuestion';
import TrueOrFalseQuestion from './mini-games/TrueOrFalseQuestion';
import { motion } from 'framer-motion';

const miniGames = ['guessYear', 'whichCameFirst', 'fillInBlank', 'trueOrFalse'];

const MasterQuiz = ({ events, onQuit }) => {
  const { t } = useTranslation();
  const [questionsLeft, setQuestionsLeft] = useState(10);
  const [currentMiniGame, setCurrentMiniGame] = useState('');
  const [score, setScore] = useState(0);
  const [gameOver, setGameOver] = useState(false);
  const [currentQuestionData, setCurrentQuestionData] = useState(null);

  useEffect(() => {
    if (events.length) {
      nextQuestion();
    }
  }, [events]);
  const nextQuestion = () => {
    if (questionsLeft <= 0) {
      setGameOver(true);
      return;
    }

    const randomGame = shuffle(miniGames)[0];
    setCurrentMiniGame(randomGame);
    const shuffled = shuffle(events);

    if (randomGame === 'guessYear' || randomGame === 'fillInBlank' || randomGame === 'trueOrFalse') {
      setCurrentQuestionData(shuffled[0]);
    } else if (randomGame === 'whichCameFirst') {
      setCurrentQuestionData([shuffled[0], shuffled[1]]);
    }
  };

  const handleCorrect = () => {
    setScore(prev => prev + 1);
    setQuestionsLeft(prev => prev - 1);
    nextQuestion();
  };

  const handleWrong = () => {
    setQuestionsLeft(prev => prev - 1);
    nextQuestion();
  };
  if (gameOver) {
    return (
      <div className="max-w-xl mx-auto p-6 bg-gray-900 text-white rounded-lg shadow-xl mt-10 text-center">
        <h2 className="text-3xl font-bold text-purple-400 mb-4">{t('master.gameOver')}</h2>
        <p className="text-lg text-green-400 mb-6">
          {t('master.finalScore', { score })}
        </p>
        <button
          onClick={onQuit}
          className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-semibold"
        >
          🔙 {t('master.returnToMenu')}
        </button>
      </div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="max-w-2xl mx-auto p-6 bg-gray-900 text-white rounded-lg shadow-xl mt-10"
    >
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-purple-400">
          🎯 {t('master.title')} ({10 - questionsLeft + 1}/10)
        </h2>
        <button
          onClick={onQuit}
          className="text-red-400 hover:text-red-500 text-sm font-bold"
        >
          ✖️ {t('master.quit')}
        </button>
      </div>

      {currentMiniGame === 'guessYear' && (
        <GuessTheYearQuestion event={currentQuestionData} onCorrect={handleCorrect} onWrong={handleWrong} />
      )}
      {currentMiniGame === 'whichCameFirst' && (
        <WhichCameFirstQuestion events={currentQuestionData} onCorrect={handleCorrect} onWrong={handleWrong} />
      )}
      {currentMiniGame === 'fillInBlank' && (
        <FillInTheBlankQuestion event={currentQuestionData} onCorrect={handleCorrect} onWrong={handleWrong} />
      )}
      {currentMiniGame === 'trueOrFalse' && (
        <TrueOrFalseQuestion event={currentQuestionData} onCorrect={handleCorrect} onWrong={handleWrong} />
      )}

      <div className="mt-6 text-center text-gray-400 text-sm">
        {t('master.score')}: {score} / 10
      </div>
    </motion.div>
  );
};

export default MasterQuiz;